module.exports = __webpack_public_path__ + "static/RootSans-14UltraItalic-a5fad479ca5cca3e5b9aad22f7d78004.woff";